import React from 'react'
import { motion } from "framer-motion";
import NavigationButton from './NavigationButton';

const LeftImage = ({myId, myImg, myTitle, myText, selectorUp, selectorDown}) => {
  return (
    <motion.div initial={{ opacity: 0}} whileInView={{ opacity: 1}}  transition={{ delay: 0.2, duration: 2}} >
            <section id={myId} className="section-image-bg section-full-frame">
                <div className="row section-full-frame d-flex justify-content-between align-items-center section-diviser">
                    <div className="col-sm-12 d-flex justify-content-center align-items-center">
                      <NavigationButton mySelector={selectorUp} myIcon="chevron-up" hasMargin={false}/> 
                    </div>
                    <div className="col-sm-12 col-md-6 p-0 d-flex justify-content-center align-items-center">
                       <img className="section-full-frame ps-5 rounded-5" style={{ maxHeight: '650px' }} src={myImg} alt="bedroom" />
                    </div>
                    <div className="col-sm-12 col-md-6 d-flex flex-column justify-content-between align-items-center section-with-image">
                        <article>
                          <h2 className="title mb-5 text-left display-5">{myTitle}</h2>
                          <p>{myText}</p>
                        </article>
                    </div>
                    <div className="col-sm-12 d-flex justify-content-center align-items-start">
                      <NavigationButton mySelector={selectorDown} myIcon="chevron-down" hasMargin={true}/>
                    </div>
                </div>
            </section>
        </motion.div>
  )
}

export default LeftImage